import {SingleLineStructuredText} from '~/cms/components/SingleLineStructuredText'
import {
  HgWYSIWYGTable,
  type WYSIWYGTableRow,
} from '~/design-system/hg/components/HgWYSIWYG/_components/Table'
import {wysiwygComponentVariants} from '../../_utils/variants'
import {
  type WysiwygTableFragment,
  type WysiwygTableRowFragment,
} from './_generated/fragment.graphql'

type DatoWYSIWYGTableProps = WysiwygTableFragment

export const DatoWYSIWYGTable = ({
  columnTitles,
  tableRows,
  useAsymmetricLayout,
}: DatoWYSIWYGTableProps) => {
  const {table} = wysiwygComponentVariants()
  const formatTableRow = (row: WysiwygTableRowFragment) => {
    const {cells} = row
    return cells.map(({body, title}) => ({
      type: 'text',
      body: body && <SingleLineStructuredText data={body} />,
      title: title && <SingleLineStructuredText data={title} />,
    })) as WYSIWYGTableRow
  }

  return (
    <HgWYSIWYGTable
      columnTitles={columnTitles ? formatTableRow(columnTitles) : null}
      rows={tableRows.map(formatTableRow)}
      asymmetrical={!!useAsymmetricLayout}
      className={table()}
    />
  )
}
